import { HttpStatusCode } from './types/HttpStatusCode';
import { contentStore, isContentDraft } from '@lib/store/Contentstore';

const DEFAULT_AUTH_ENDPOINT = '/api/auth/authenticate';

const parseAuthLocation = (locationHeader: string | null) => {
  if (!locationHeader) {
    return DEFAULT_AUTH_ENDPOINT;
  }

  try {
    const url = new URL(locationHeader, location.origin);
    return `${url.origin}${url.pathname}`;
  }
  catch {
    return DEFAULT_AUTH_ENDPOINT;
  }
};

const apiClient = {
  async fetch(
    postAuthReturnUrl: string | URL,
    requestUrl: string | URL,
    requestInit?: RequestInit,
  ) {
    const fullUrl = new URL(String(requestUrl), location.origin);

    const isDraft = contentStore.get(isContentDraft);
    if (isDraft) {
      fullUrl.searchParams.set('mode', '1');
    }
    const response = await fetch(fullUrl, requestInit);

    if (response.status === HttpStatusCode.Status401Unauthorized) {
      const authLocation = parseAuthLocation(response.headers.get('Location'));
      const authUrl = new URL(authLocation, location.origin);
      authUrl.searchParams.set('returnUrl', String(postAuthReturnUrl));
      window.location.href = authUrl.toString();
      throw response;
    }
    else if (response.status === HttpStatusCode.Status403Forbidden) {
      return response;
    }
    else if (response.status === HttpStatusCode.Status404NotFound) {
      return response;
    }
    else if (!response.ok) {
      throw response;
    }

    return response;
  },
};

export default apiClient;
